// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__puycw","left":"Virtual_left__IpKEq","wrapper":"Virtual_wrapper__f813l"};